import {
  Button,
  type ButtonProps,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui'
import { SelectPlanForm } from './SelectPlanForm'

export const UpgradeButton = ({
  children = 'Upgrade',
  ...buttonProps
}: ButtonProps) => (
  <Dialog>
    <DialogTrigger asChild>
      <Button {...buttonProps}>{children}</Button>
    </DialogTrigger>
    <DialogContent className="max-h-[90vh] max-w-5xl overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="text-2xl">Upgrade</DialogTitle>
        <DialogDescription className="text-base">
          Pick a plan to keep working on your case.
        </DialogDescription>
      </DialogHeader>
      <SelectPlanForm />
    </DialogContent>
  </Dialog>
)
